"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProductQueryResponse = exports.commercetoolsRequestProductByKey = void 0;
const monet_1 = require("monet");
const commercetools_1 = require("../secrets/commercetools");
const commercetoolsClient_1 = require("./commercetoolsClient");
const products_1 = require("./products");
const commercetoolsRequestProductByKey = (productKey) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.productUrl}/product-projections/key=${productKey}?priceCurrency=GBP&priceCountry=GB&priceChannel=1bfff3c2-3c0d-4ad2-9a02-1917f2918c9b&expand=masterVariant.prices[*].customerGroup.id&expand=masterVariant.prices[*].discounted.discount.id`,
    method: 'GET'
});
exports.commercetoolsRequestProductByKey = commercetoolsRequestProductByKey;
const parseProductQueryResponse = (productKey) => (res) => res
    .chain(val => monet_1.Maybe.fromUndefined((0, products_1.parseRawProducts)([val])[0]))
    .toEither(Error(`Product response does not contain any results: ${productKey}`));
exports.parseProductQueryResponse = parseProductQueryResponse;
//# sourceMappingURL=query.js.map